import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "onClick"]

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ref } from 'vue';
import { useCheckout } from '@/b2b/checkout/useCheckout';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentFinalizeBankTransfer',
  setup(__props) {

const pending = ref<boolean>(false);
const labels = useBlockLabels();
const { submitOrderWithB2BPayment, initializePayment, setItemIdsOutOfStock, setEarliestDeliveryDateChanged } = useCheckout();

const startPayment = async() => {
    const result = await initializePayment();
    if (result.itemsOutOfStock?.length) {
        setItemIdsOutOfStock(result.itemsOutOfStock);
    } else if (result.requiredEarliestDeliveryDate) {
        setEarliestDeliveryDateChanged(true);
    } else {
        pending.value = true;
        await submitOrderWithB2BPayment();
        pending.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "c-button c-button--primary",
    disabled: pending.value,
    onClick: _withModifiers(startPayment, ["prevent"])
  }, _toDisplayString(_unref(labels).paymentStepButtonConfirmAndSubmit), 9, _hoisted_1))
}
}

})